var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_830",
    "data-name": "Group 830",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 41.053,
    viewBox: "0 0 41 41.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6253",
    "data-name": "Rectangle 6253",
    width: 41,
    height: 41.053,
    fill: "#00A19B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18615",
    "data-name": "Path 18615",
    d: "M0,20.6a20.5,20.5,0,0,0,41,.054A20.653,20.653,0,0,0,20.568,0,20.431,20.431,0,0,0,0,20.6m15.659,1.667c.192.209.3.333.415.451.784.8,1.578,1.6,2.351,2.415a1.564,1.564,0,0,1-2.222,2.2q-2.78-2.817-5.532-5.661a1.544,1.544,0,0,1,.026-2.317q2.787-2.81,5.6-5.6a1.568,1.568,0,1,1,2.2,2.229c-.814.823-1.637,1.637-2.453,2.458a4.245,4.245,0,0,0-.269.34h.64q6.205,0,12.41,0a1.751,1.751,0,1,1-.021,3.479q-4.162,0-8.325,0H15.658",
    transform: "translate(0.001 0)",
    fill: "#00A19B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/Back-Arrow.62b736eeb04a2d09eae58a4f7b77cfff.svg";
export { ForwardRef as ReactComponent };